export default __webpack_public_path__ + "static/media/comment.b4bab621.png";